/* istanbul ignore file */
import { DataGridLayout } from 'framework/list';
import { TextField } from 'framework/ui/field';
import ArtifactStorageFolderField from 'domain/documents/artifactStorage/shared/field/ArtifactStorageFolderField';
import { ArtifactStorageTypeIcon, ArtifactType } from 'domain/shared/artifactStorage';
import { FormFieldsData } from 'framework/form';

const ArtifactStorageFoldersListLayout = () => {
  return (
    <DataGridLayout>
      <ArtifactStorageTypeIcon label="" source="type" width={45} />
      <ArtifactStorageFolderField source="folder" label="Name" isVisible={data => data.type === ArtifactType.FOLDER} />
      <TextField
        source="folder.totalItemCount"
        label="Number of files"
        isVisible={(data: FormFieldsData) => data.type === ArtifactType.FOLDER}
      />
    </DataGridLayout>
  );
};

export default ArtifactStorageFoldersListLayout;
